import(/* webpackMode: "eager", webpackExports: ["SearchPage"] */ "/vercel/path0/src/features/content-search/ui/SearchPage.tsx");
